import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { sections, useSection } from "hooks/section";
import { isMobile } from "react-device-detect";
import studentJobbImg from "assets/studentjobb.webp";

import "./Heading.css";
import Panorama from "./Panorama";
import { useEffect } from "react";

function Studentjobb() {
    const navigate = useNavigate();
    const adTypes = [
        { className: "button-jobb", adType: "4", title: "Jobb" },
        { className: "button-trainee", adType: "1", title: "Traineeprogram" },
        { className: "button-intnernship", adType: "2", title: "Internship" },
        { className: "button-exam", adType: "3", title: "Examensarbete" },
    ];
    const top = isMobile ? 700 :"unset";
    
    return (
        <div className="Heading background-grey margin-top">
            <img alt="TODO" src={studentJobbImg} loading="lazy" width="200px" height="300px" />
            <div className="studentjobb-layout">
                <h1>
                    Här hittar du arbetsgivare som exempelvis erbjuder Traineeprogram, Internship, Examensarbete,
                    Sommarjobb, Extrajobb och liknande
                </h1>
                <h2>Vad söker du?</h2>
                <Row>
                    {adTypes.map((at) => {
                        return (
                            <Col lg={3} xs={12}>
                                <Button
                                    className={"button-rounded " + at.className}
                                    onClick={() => {
                                        navigate(`?adTypes=${at.title}`);
                                        window.scroll({
                                            top: top,
                                            left: 0,
                                            behavior: "smooth",
                                        })
                                    }}
                                >
                                    {at.title}
                                </Button>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </div>
    );
}

export default function Heading() {
    const { sectionEnum } = useSection();

    const map = {
        // [sections.EFTERGYMASIAL_UTBILDNING]: EftergymnasialUtbildning,
        // [sections.GYMNASIUM]: Gymnasium,
        // [sections.KOMPETENSUTVECKLING]: Kompetensutveckling,
        [sections.STUDENTJOBB]: Studentjobb,
    };

    const CorrectHeading = map[sectionEnum];

    if (CorrectHeading) {
        return (
            <Container className="mb-3 margin-top">
                <Row className="mb-3">
                    <Col>
                        <CorrectHeading />
                    </Col>
                </Row>
            </Container>
        );
    } else {
        return (<div className="margin-top" > <Panorama /></div>);
    }

    return false;
}
